<template>
  <div>
    <b-collapse class="card mb-1" :open="false">
      <div slot="trigger" class="panel-heading">
        <div class="customer-record">
          <p><i class="fas fa-user pr-1"></i>{{order.customerDetails.name}}</p>
          <p><i class="fas fa-phone pr-1"></i>{{order.customerDetails.contact}}</p>
          <p><i class="fas fa-clock pr-1"></i>{{ new Date(order.deliveryOptionDate) | moment("DD/MM/YYYY, h:mm:ss A")}}</p>
          <p><i class="fas fa-truck pr-1"></i>{{order.orderStatus}}</p>
        </div>
      </div>
        <div class="card-content">
          <strong>Order details</strong>
          <div class="customer-record mb-1">
            <p>Order id: {{order.docId}}</p>
            <p :title="order.shippingAddress">Shipping address: {{order.shippingAddress | truncate(30)}}</p>
            <p>Delivery boy: Romesh patel (+918866323155)</p>
          </div>
          <strong>Payment details</strong>
            <div class="customer-record mb-1">
              <p>Total cost: {{order.totalCost | currency('Rs.')}}</p>
              <p>Delivery charges: {{order.deliveryCharges | currency('Rs.')}}</p>
              <p>Payment mode: {{order.paymentMode}}</p>
              <p>Amount collectable: {{order.amountPayable || 0  | currency('Rs.')}}</p>
          </div>
          <p class="mt-1">Order items</p>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Name</th>
                <th>How much</th>
                <th>Rate</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in order.orderItems" :key="index">
                  <td>{{index+1}}</td>
                  <td>
                    <a :href="item.imageUrl" target="_blank">
                      <img :src="item.imageUrl" :alt="item.name" class="image is-48x48">
                    </a>
                  </td>
                  <td>{{item.name}}</td>
                  <td>{{item.quantity}} x {{item.howMuch}}</td>
                  <td>{{item.ourPrice | currency('Rs.')}}</td>
                </tr>
            </tbody>
          </table>
        </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "orderCard",

  props: ["order"]
};
</script>

<style scoped>
.customer-record {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/Orders/OrderCard.vue